import React from 'react';
import { Link } from 'react-router-dom';

const FooterOne = () => {
    return (
        <>
            <div className="footer__area section-padding">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-7 col-lg-7">
                            <div className="footer__area-widget">
                                <div className="footer__area-widget-about lg-t-center">
                                    <div className="footer__area-widget-about-logo">
                                        <Link to="/"><img src="assets/img/logo-1.png" alt="" /></Link>
                                    </div>
                                    <div className="footer__area-widget-about-social">
                                        <ul>
                                            <li><a target='_blank' href='https://t.me/tmt_org'><i className="fab fa-telegram"></i></a> </li>
                                            <li><a target='_blank' href='https://discord.gg/UCCjYYWz33'><i className="fab fa-discord"></i></a> </li>
                                            <li><a target='_blank' href='https://www.instagram.com/tmt_org'><i className="fab fa-instagram"></i></a> </li>
                                        </ul>
                                    </div>
                                    <div className="footer__area-widget-about-menu">
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/tournaments">Tournaments</Link></li>
                                            <li><Link to="/prorating">Ratings</Link></li>
                                            <li><Link to="/news">News</Link></li>
                                            <li><Link to="/scam">Scam list</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright__area copyright__area-one">
                <div className="container">
                    <div className="row align-items-center copyright__area-border">
                        <div className="col-xl-12">
                            <div className="copyright__area-left copyright__area-one-left">
                                <p>Copyright © { new Date().getFullYear() }<Link to="/"> Pubgm-tmt</Link> Website by TOT STUDIO </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FooterOne;